import React from 'react';
import styles from './DENTToothPeriodontalLine.module.scss';
import { Scale } from '../../../Base/Interfaces/Scale.interface';
import DENTToothPeriodontalLines from './DENTToothPeriodontalLines';
import useGridCalculation from '../../Hooks/Tooth/PeriodontalLines/useGridCalculation';
import usePeriodontalData from '../../Hooks/Tooth/PeriodontalLines/usePeriodontalData';
import usePeriodontalPointsDetail from '../../Hooks/Tooth/PeriodontalLines/usePeriodontalPointsDetail';
import useRenderSize from '../../Hooks/Tooth/PeriodontalLines/useRenderSize';
import { TOOTH_IMAGE_BASE } from '../../Helpers/periodontalLines/toothImageBase';
import { PeriodontalToothView } from '../../Interfaces/PeriodontalToothView.type';
import { Tooth } from '../../../../graphql/graphql';

interface Props {
	tooth: Tooth;
	scale: Scale;
	view: PeriodontalToothView;
}

const DENTToothPeriodontalLineDetail = ({ tooth, scale, view }: Props) => {
	const { periodontal } = tooth;

	const { margins, depths } = usePeriodontalData({
		periodontal,
		view,
		side: tooth.side,
	});
	const { base, renderSize } = useRenderSize(scale);
	const { defaultY, middlePointY, distance, isUp } = useGridCalculation({
		tooth,
		view,
		renderSize,
	});

	const { marginPoints, depthPoints } = usePeriodontalPointsDetail({
		toothType: tooth.type!,
		base,
		defaultY,
		middlePointY,
		distance,
		margins,
		depths,
	});

	return (
		<div className={styles.wrapper}>
			<DENTToothPeriodontalLines
				viewBox={TOOTH_IMAGE_BASE}
				containerSize={{ w: 0, h: base.h }}
				isUp={isUp}
				depthPoints={depthPoints}
				marginPoints={marginPoints}
			/>
		</div>
	);
};

export default DENTToothPeriodontalLineDetail;
